import store from '../../redux/store/store'
import { hide, show } from "../../redux/slice/SettingSlice";
import axios from "axios";
import { errorToast, successToast } from '../../helper/FormHelper'
import { getToken } from "../helper/SessionHelper";
import { BaseURL, RolePermissionDeleteURL, UserRoleListURL, PermissionListURL, UserRoleCreateURL, RolePermissionShowURL, UserRoleUpdateURL } from "../helper/Config";
import { setUserRoleList, onChangeUserRolePermissionFormInput, setSelectedPermissions, setPermissionList, resetUserRolePermissionFormValue } from '../../redux/slice/admin/UserRoleSlice';
const AxiosHeader = {
    headers: {
        "Authorization": `Bearer ${getToken()}`
    }
}

export async function RoleCreateRequest(postBody, id) {
    try {
        store.dispatch(show())
        let URL = BaseURL + UserRoleCreateURL
        let method = 'post';
        if (id !== 0) {
            URL = BaseURL + UserRoleUpdateURL + "/" + id;
            method = "put";
        }
        const result = await axios({
            method,
            url: URL,
            data: postBody,
            headers: AxiosHeader.headers
        });
        store.dispatch(hide())
        if (result.data.status === true) {
            successToast("Request Successful");
            store.dispatch(resetUserRolePermissionFormValue())
            return true;
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
            return false;
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
        return false
    }
}

export async function GetUserRoleList() {
    try {
        store.dispatch(show())
        let URL = BaseURL + UserRoleListURL;
        const result = await axios.get(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {

            store.dispatch(setUserRoleList(result.data.data))
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
    }
}

export async function GetPermissionList() {
    try {
        store.dispatch(show())
        let URL = BaseURL + PermissionListURL;
        const result = await axios.get(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {

            store.dispatch(setPermissionList(result.data.data))
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
    }
}
export async function DeleteUserRole(id) {
    try {
        store.dispatch(show())
        let URL = BaseURL + RolePermissionDeleteURL + "/" + id;
        const result = await axios.delete(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {
            successToast(result.data.message)
            return true
        }
        if (result.data.status === false) {
            errorToast(result.data.message)
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
    }
}

export async function FillUserRoleFormRequest(id) {
    try {
        store.dispatch(show())
        let URL = BaseURL + RolePermissionShowURL + "/" + id;
        const result = await axios.get(URL, AxiosHeader)
        store.dispatch(hide())
        if (result.data.status === true) {
            let formValue = result.data.data
            let permissions = formValue.permissions.map(permission => permission.name);
            store.dispatch(onChangeUserRolePermissionFormInput({ name: "name", value: formValue.name }));
            store.dispatch(setSelectedPermissions(permissions));
            return true;
        } else {
            errorToast("Request Fail ! Try Again")
            return false;
        }
    } catch (e) {
        errorToast("Something Went Wrong")
        store.dispatch(hide())
        return false
    }
}